export default __webpack_public_path__ + "static/media/santa.e9ebc07d.svg";